export function isError(o?: any): o is Error {
    return o instanceof Error;
}